import personaData from './mock';
import { isTestEnvironment } from '../../util/environment';

export default function () {
  if (isTestEnvironment()) return this.get('/api/personas/persona', this.passthrough);

  return this.get('/api/personas/persona', () => [
    200,
    { 'Content-Type': 'application/json' },
    JSON.stringify(personaData.PERSONA_DATA_NO_GOALS_COMPLETE)
  ]);
}
